export default {
  path: '/ratio-publish',
  meta: {
    title: '我的发布',
    keepAlive: true,

  },
  component: r => require.ensure([], () => r(require(`./index.vue`)), `/ratio-publish`),
}



// WEBPACK FOOTER //
// ./src/views/RatioPublish/router.js